import React from "react";
import Customer from "./customers.png";

function Hero() {
  return (
    // <div className="bgi-no-repeat bgi-size-cover bgi-position-x-center bgi-position-y-bottom landing-light-bg" style={{zIndex: "-1", backgroundAttachment: "fixed"}} >
    <div className="container">
      <div className="d-lg-flex justify-content-between align-items-center">
        <div className="">
          <div className="mb-2 mb-lg-2 d-sm-block py-5 py-lg-20 ps-lg-0 ps-10">
            <h1 className="fs-2x fs-lg-4x mb-10">
              <span className="fs-4x primary-color">3rdRetail</span> is Building{" "}
              <br></br> Africa’s Largest <br></br>Distribution Network
            </h1>
            <div className="d-flex">
              <div>
                <a
                  href="/Pagenotfound.html"
                  className="btn btn-lg getstartedBtn"
                >
                  Get Started
                </a>
              </div>
              <div>
                <a
                  href="/Pagenotfound.html"
                  className="btn btn-lg sm-btn-sm learnBtn"
                >
                  Login
                </a>
              </div>
            </div>

            <div className="mb-3 mt-14 mb-lg-2 d-sm-block">
              <div className="mb-3">
                <img src={Customer} alt="customerimg" />
              </div>
              <div>
                <h5>
                  Over{" "}
                  <span id="color10k" className="fw-bolder mt-4">
                    10,000+
                  </span>{" "}
                  goods sold last year!
                </h5>
              </div>
            </div>
          </div>
        </div>

        <div className="heroImg">
          <div className="blob2 d-none d-lg-block d-md-block"></div>
          <img
            src={"./resources/img/heroimg.png"}
            className={"img-fluid"}
            alt="HeroImg"
            width="550px"
            height="582px"
          />
        </div>
      </div>
    </div>

    //  </div>
  );
}

export default Hero;
